import { accessAllTariffPlansList, accessLightAndStandardPlansList } from 'constants/accessPlanLists';
import {
  IForInvestorsSections,
  FOR_INVESTORS_SECTIONS as S,
  FOR_INVESTORS_SUB_SECTIONS as SS,
} from 'constants/businessToolSections/forInvestors';

import { ISectionAccess } from './interface';

type IAccessibilityRules = {
  [K in IForInvestorsSections]: ISectionAccess;
};
export const forInvestorsAccessibilityRules: IAccessibilityRules = {
  [S.OVERVIEW]: {
    _accessPlan: accessAllTariffPlansList,

    [SS.FOR_INVESTORS_OVERVIEW.COMPANY]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_OVERVIEW.PROJECT]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_OVERVIEW.MARKET_CUSTOMERS]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_OVERVIEW.FINANCIAL_INFO]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_OVERVIEW.FUNDING_NEEDS]: accessAllTariffPlansList,
  },
  [S.EXECUTIVE_SUMMARY]: {
    _accessPlan: accessAllTariffPlansList,

    [SS.FOR_INVESTORS_EXECUTIVE_SUMMARY.GOALS_AND_OBJECTIVES]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_EXECUTIVE_SUMMARY.COMPANY_DESCRIPTION]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_EXECUTIVE_SUMMARY.PRODUCTS_OR_SERVICES]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_EXECUTIVE_SUMMARY.MARKET_AND_CUSTOMERS]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_EXECUTIVE_SUMMARY.ORGANIZATION_AND_TEAM]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_EXECUTIVE_SUMMARY.FINANCIAL_INFORMATION]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_EXECUTIVE_SUMMARY.FINANCING_NEEDS]: accessAllTariffPlansList,
  },
  [S.COMPANY_AND_PROJECT]: {
    _accessPlan: accessAllTariffPlansList,

    [SS.FOR_INVESTORS_COMPANY_AND_PROJECT.GENERAL_INFO]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_COMPANY_AND_PROJECT.COMPANY_HISTORY]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_COMPANY_AND_PROJECT.ABOUT_THE_PROJECT]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_COMPANY_AND_PROJECT.IMPLEMENTATION_PLAN]: accessAllTariffPlansList,
    [SS.FOR_INVESTORS_COMPANY_AND_PROJECT.SWOT]: accessAllTariffPlansList,
  },
  [S.MARKET_ANALYSIS]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_INVESTORS_MARKET_ANALYSIS.MARKET_OVERVIEW]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_MARKET_ANALYSIS.COMPETITIVE_ANALYSIS]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_MARKET_ANALYSIS.CONSUMER_NEEDS]: accessLightAndStandardPlansList,
  },
  [S.MARKETING_AND_SALES]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_INVESTORS_MARKETING_AND_SALES.SALES_PLAN]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_MARKETING_AND_SALES.MARKETING_PLAN]: accessLightAndStandardPlansList,
  },
  [S.BUSINESS_OPERATIONS]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_INVESTORS_BUSINESS_OPERATIONS.LOCATION_AND_PREMISES]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_BUSINESS_OPERATIONS.EQUIPMENT]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_BUSINESS_OPERATIONS.ASSETS]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_BUSINESS_OPERATIONS.TECHNOLOGICAL_PROCESS]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_BUSINESS_OPERATIONS.PRODUCTION]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_BUSINESS_OPERATIONS.PRODUCT_DESCRIPTION]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_BUSINESS_OPERATIONS.UNIQUENESS]: accessLightAndStandardPlansList,
  },
  [S.MANAGEMENT_AND_ORGANIZATION]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_INVESTORS_MANAGEMENT_AND_ORGANIZATION.MANAGEMENT_TEAM]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_MANAGEMENT_AND_ORGANIZATION.STAFF_ORGANIZATION]: accessLightAndStandardPlansList,
  },
  [S.RAISING_AND_ALLOCATING_FUNDS]: {
    _accessPlan: accessLightAndStandardPlansList,
  },
  [S.FINANCIAL_PLAN]: {
    _accessPlan: accessLightAndStandardPlansList,

    [SS.FOR_INVESTORS_FINANCIAL_PLAN.KEY_ASSUMPTIONS]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_FINANCIAL_PLAN.REVENUE_PLAN]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_FINANCIAL_PLAN.PLANNED_EXPENSES]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_FINANCIAL_PLAN.PROFIT_AND_LOSS]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_FINANCIAL_PLAN.CASH_FLOW_ELEMENTS]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_FINANCIAL_PLAN.PROJECTED_CASH_FLOW]: accessLightAndStandardPlansList,
    [SS.FOR_INVESTORS_FINANCIAL_PLAN.FINANCIAL_PERFORMANCE]: accessLightAndStandardPlansList,
  },
};
